module.exports = __webpack_public_path__ + "img/SmartphonesWife2.f4144746.png";